export default __webpack_public_path__ + "static/media/Thief's Fauld of the Nadir.cfa2c2b1.jpg";